/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlockGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Block Group Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 07:28:04 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const BLOCKGROUP_LIST_CONTAINER_LOADED = 'BLOCKGROUP_LIST_CONTAINER_LOADED';
export const BLOCKGROUP_LIST_CONTAINER_UNLOADED = 'BLOCKGROUP_LIST_CONTAINER_UNLOADED';
export const BLOCKGROUP_LIST_TABLE_LOADED = 'BLOCKGROUP_LIST_TABLE_LOADED';
export const BLOCKGROUP_LIST_TABLE_UNLOADED = 'BLOCKGROUP_LIST_TABLE_UNLOADED';

export const BLOCKGROUP_SELECT_ROW = 'BLOCKGROUP_SELECT_ROW';

export const BLOCKGROUP_ADD = 'BLOCKGROUP_ADD';
export const BLOCKGROUP_EDIT = 'BLOCKGROUP_EDIT';
export const BLOCKGROUP_DELETE = 'BLOCKGROUP_DELETE';
export const BLOCKGROUP_OPEN_WARNING = 'BLOCKGROUP_OPEN_WARNING';
export const BLOCKGROUP_CLOSE_WARNING = 'BLOCKGROUP_CLOSE_WARNING';
export const BLOCKGROUP_DELETE_DISABLE = 'BLOCKGROUP_DELETE_DISABLE';
export const BLOCKGROUP_VIEW_CHILD_ITEMS = 'BLOCKGROUP_VIEW_CHILD_ITEMS';

export const BLOCKGROUP_EDIT_CONTAINER_LOADED = 'BLOCKGROUP_EDIT_CONTAINER_LOADED';
export const BLOCKGROUP_EDIT_CONTAINER_UNLOADED = 'BLOCKGROUP_EDIT_CONTAINER_UNLOADED';
export const BLOCKGROUP_EDIT_TABGROUPS_LOADED = 'BLOCKGROUP_EDIT_TABGROUPS_LOADED';
export const BLOCKGROUP_EDIT_SET_TABGROUP_OPTIONS = 'BLOCKGROUP_EDIT_SET_TABGROUP_OPTIONS';
export const BLOCKGROUP_EDIT_SET_TAB_OPTIONS = 'BLOCKGROUP_EDIT_SET_TAB_OPTIONS';
export const BLOCKGROUP_EDIT_FORM_LOADED = 'BLOCKGROUP_EDIT_FORM_LOADED';
export const BLOCKGROUP_EDIT_FORM_UNLOADED = 'BLOCKGROUP_EDIT_FORM_UNLOADED';

export const BLOCKGROUP_EDIT_DATA_LOAD = 'BLOCKGROUP_EDIT_DATA_LOAD';

export const BLOCKGROUP_EDIT_CONTAINER_SUBMIT = 'BLOCKGROUP_EDIT_CONTAINER_SUBMIT';
export const BLOCKGROUP_EDIT_CONTAINER_CANCEL = 'BLOCKGROUP_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlockGroups.js